<template>
  <div class="footerGuide">
    <div class="guideItem" v-for="(item, i) in footerList" :key="i"
         @click="gotoRoute(item.name, i)">
      <img :src="fetchCurrentRoute(item.name)?item.srcAct:item.src" alt="">
      <div class="label" :class="{'labelAct': fetchCurrentRoute(item.name)}">{{ item.label }}</div>
    </div>
  </div>
</template>

<script>
import {mapMutations} from 'vuex'
import {separateThousand, separateThousandInteger} from '@/utils'
import Home from '@/assets/images/footerGuide/Home.svg'
import HomeAct from '@/assets/images/footerGuide/HomeAct.svg'
import TrainingAct from '@/assets/images/footerGuide/TrainingAct.svg'
import Training from '@/assets/images/footerGuide/Training.svg'
import invite from '@/assets/images/footerGuide/Invite.svg'
import inviteAct from '@/assets/images/footerGuide/InviteAct.svg'
import my from '@/assets/images/footerGuide/My.svg'
import myAct from '@/assets/images/footerGuide/MyAct.svg'

export default {
  name: 'FooterGuide',
  data () {
    return {
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      workOrderMessageCount: 0,
      shouldShowInviteRedDot: false,
      InviteBet: false,
      isCallBack: false,
      isTwice: false,
      todayShow: false,
      footerList: [
        {
          label: this.$t('lang.footer.Home'),
          name: 'Home',
          src: Home,
          srcAct: HomeAct
        },
        {
          label: this.$t('lang.footer.Training'),
          name: 'Training',
          src: Training,
          srcAct: TrainingAct
        },
        {
          label: this.$t('lang.footer.Invite'),
          name: 'Invite',
          src: invite,
          srcAct: inviteAct
        },
        {
          label: this.$t('lang.footer.My'),
          name: 'My',
          src: my,
          srcAct: myAct
        }
      ],
      winnerList: [],
      fetchCurrency: {
        zh: '￥',
        en: '$',
        id: '₹'
      },
      separateThousand,
      showGame: false,
      gameInfo: {},
      winnerTimeout: null,
      winnerInterval: null,
      isAppCid: localStorage.getItem('isAppCid') === 'true',
      bubbleSetting: '',
      accountInfo: {},
      activity: {}
    }
  },
  watch: {},
  computed: {
    fetchCurrentRoute () {
      return (label) => {
        return label === this.$route.name
      }
    }
  },
  components: {},
  mounted () {
  },
  beforeDestroy () {
  },
  methods: {
    separateThousandInteger,
    ...mapMutations({
      setCurrentRoute: 'setCurrentRoute'
    }),
    gotoRoute (label) {
      this.setCurrentRoute(label)
      this.$router.push('/' + label)
    }
  }
}
</script>

<style lang="less" scoped>
.footerGuide {
  position: fixed;
  bottom: 0;
  width: 100vw;
  height: calc(64vw / 3.6);
  background: var(--white);
  display: flex;
  align-items: center;
  justify-content: space-around;
  text-align: center;
  z-index: 99999;

  .guideItem {
    position: relative;
    width: calc(44vw / 3.6);
    height: calc(44vw / 3.6);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    img {
      width: auto;
      height: calc(16.5vw / 3.6);
    }

    .label {
      margin-top: 0.75vw;
      font-weight: 600;
      font-size: calc(11vw / 3.6);
      letter-spacing: 0.05em;
      color: var(--footer);
    }

    .labelAct {
      color: var(--footerAct);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/FooterGuide/index.vue